<template>
  <div>
    <List
      url="device-info/models/"
      :title="title"
      :data="searchData"
      :tanle="tanle"
      :afterList="dealList"
      :operat="operation"
      :update="updateList"
      :MultipleSel="true"
      @edit="edit"
      @deletedata="deletedata"
    >
      <div slot="Fresh" style="float:right;">
        <el-select multiple v-model="selectDeviceTypes" placeholder="选择设备类型(多选)" @change="search" style="width:200px;margin-right:10px;" size="small">
          <el-option
            v-for="device_type in DeviceTypesList"
            :label="device_type"
            :key="device_type"
            :value="device_type"></el-option>
        </el-select>

        <el-input
          v-model="searchData.name"
          size="small"
          style="width:200px;margin-right:10px;"
          placeholder="请输入设备机型型号"
          @change="search"
        ></el-input>
        <el-input
          v-model="searchData.firmware_version_field1"
          size="small"
          style="width:200px;margin-right:10px;"
          placeholder="请输入设备固件版本前缀(如 563.30 / 563.30.15)"
          @change="search"
        ></el-input>
        <el-button @click="add" type="primary" size="small" icon="el-icon-edit">新增</el-button>
        <el-button @click="updateList++" type="primary" size="small">刷新列表</el-button>
      </div>
    </List>
    <DeviceModelsUpdateBox
      :initForm="updateForm"
      :updateType="updateType"
      v-if="updateBlock"
      @close="close"
      @update="updateList++"
      :deviceTypesList="DeviceTypesList"
    ></DeviceModelsUpdateBox>
  </div>
</template>

<script>
import List from "../components/common/List.vue";
import DeviceModelsUpdateBox from "../components/DeviceInfo/DeviceModelsUpdateBox.vue";

export default {
  components: {
    List,
    DeviceModelsUpdateBox
  },
  data() {
    return {
      dialogFormVisible: false,
      DeviceTypesList: [],
      selectDeviceTypes: [],
      title: "设备机型",
      tanle: [
        { name: "name", label: "机型型号" },
        { name: "firmware_version_field1", label: "固件版本前缀(两段或三段)" },
        { name: "device_type", label: "设备类型" },
        { name: "latest_stable_firmware", label: "最新正式版本", status: "copyFirmware", type: "stable" },
        { name: "latest_beta_firmware", label: "最新Beta版本", status: "copyFirmware", type: "beta" },
        { name: "latest_lts_firmware", label: "最新LTS版本", status: "copyFirmware", type: "lts" },
        { name: "transitional_versions", label: "过渡版本", status: "copyFirmware", type: "transitional" },
        { name: "desc", label: "备注" }
      ],

      searchData: {
        device_type: "",
        name: "",
        firmware_version_field1: ""
      },
      operation: [
        {
          text: "Edit",
          eventName: "edit"
        },
        {
          text: "Deletedata",
          eventName: "deletedata"
        }
      ],

      updateList: 0,
      updateForm: {},
      updateType: "edit",
      updateBlock: false,
      token: ""
    };
  },
  mounted() {
    this.token = localStorage.getItem("token");
    this.fetchDeviceTypes();
  },
  methods: {
    dealList(data) {
      for (let i in data) {
        data[i].create_time = this.changeDate(data[i].create_time);
      }
      return data;
    },
    close() {
      this.updateBlock = false;
    },
    edit(val) {
      this.updateForm = Object.assign({}, val);
      this.updateType = "edit";
      this.updateBlock = true;
    },
    add() {
      this.updateType = "add";
      this.updateForm = {};
      this.updateBlock = true;
    },
    search() {
      this.searchData.device_type = this.selectDeviceTypes.join(",");
      this.updateList++;
    },
    deletedata(val) {
      let url = "device-info/models/" + val.id + "/";
      this.$http["delete"](url, () => {
        this.$baseNotice.message("删除成功");
        this.updateList++;
      });
    },
    changeDate(date) {
      var time = new Date(date);
      var nowYear = time.getFullYear().toString();
      var nowMonth = (time.getMonth() + 1).toString();
      var nowDay = time.getDate().toString();
      var nowHours = time.getHours().toString(); //获取当前小时数(0-23)
      var nowMin = time.getMinutes().toString(); //获取当前分钟数(0-59)
      var nowSeconds = time.getSeconds().toString(); //获取当前秒数(0-59)

      nowYear = this.timeAdd0(nowYear);
      nowMonth = this.timeAdd0(nowMonth);
      nowDay = this.timeAdd0(nowDay);
      nowHours = this.timeAdd0(nowHours);
      nowMin = this.timeAdd0(nowMin);
      nowSeconds = this.timeAdd0(nowSeconds);
      return (
        nowYear +
        "-" +
        nowMonth +
        "-" +
        nowDay +
        " " +
        nowHours +
        ":" +
        nowMin +
        ":" +
        nowSeconds
      );
    },
    timeAdd0(str) {
      if (str.length <= 1) {
        str = "0" + str;
      }
      return str;
    },
    fetchDeviceTypes() {
      this.$http["get"](
        "device-info/types/", {}, (data) => {
          this.DeviceTypesList = data.data.results.map(item => item.name);
        }
      );
    },
  },
  computed: {
    config() {
      return { Authorization: "JWT " + this.token };
    }
  }
};
</script>

<style lang="less" scoped>
.tag {
  height: 36px;
  width: 120px;
  line-height: 36px;
  font-size: 14px;
  background-color: #d7dbe0;
  color: #303133;
  margin-right: 20px;
  padding: 0px 16px;
  text-align: center;
}

.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>
